import moment from 'moment';

export const monthKey = (date) => moment(date).format('YYYY-MM');

export const monthLabel = (ym) => moment(ym + '-01').format("MMM 'YY");

export const monthLabelLong = (ym) => moment(ym + '-01').format('MMM YYYY');

export const monthShort = (ym) => moment(ym + '-01').format('MMM');

export const pct = (num, den) => {
	const n = parseInt(num, 10) || 0;
	const d = parseInt(den, 10) || 0;
	if (d <= 0) return null;
	return Math.round((n / d) * 1000) / 10;
};

export const deltaPoints = (cur, prev) => {
	if (cur === null || cur === undefined || prev === null || prev === undefined) return null;
	return Math.round((parseFloat(cur) - parseFloat(prev)) * 10) / 10;
};

export const deltaCount = (cur, prev) => (parseInt(cur, 10) || 0) - (parseInt(prev, 10) || 0);

export const deltaDir = (diff) => {
	if (diff === null || diff === undefined) return 'flat';
	if (diff > 0) return 'up';
	if (diff < 0) return 'down';
	return 'flat';
};
